var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRevert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39281 6.94007H22.3878C24.8616 6.94007 26.8753 8.91882 26.8753 11.3513V14.4401C26.8753 15.1313 26.3166 15.6901 25.6253 15.6901C24.9341 15.6901 24.3753 15.1313 24.3753 14.4401V11.3513C24.3753 10.2988 23.4841 9.44007 22.3878 9.44007H7.39281L9.00906 11.0563C9.49656 11.5451 9.49656 12.3351 9.00906 12.8238C8.76531 13.0676 8.44531 13.1901 8.12531 13.1901C7.80531 13.1901 7.48531 13.0676 7.24156 12.8238L3.49156 9.07382C3.00281 8.58507 3.00281 7.79507 3.49156 7.30632L7.24156 3.55632C7.72906 3.06757 8.52031 3.06757 9.00906 3.55632C9.49656 4.04507 9.49656 4.83507 9.00906 5.32382L7.39281 6.94007ZM20.9913 18.5566C21.48 18.0679 22.27 18.0679 22.7587 18.5566L26.5088 22.3066C26.9975 22.7954 26.9975 23.5854 26.5088 24.0741L22.7587 27.8241C22.515 28.0679 22.195 28.1904 21.875 28.1904C21.555 28.1904 21.235 28.0679 20.9913 27.8241C20.5025 27.3354 20.5025 26.5454 20.9913 26.0566L22.6075 24.4404H7.6125C5.1375 24.4404 3.125 22.4616 3.125 20.0291V16.9404C3.125 16.2491 3.685 15.6904 4.375 15.6904C5.065 15.6904 5.625 16.2491 5.625 16.9404V20.0291C5.625 21.0829 6.51625 21.9404 7.6125 21.9404H22.6075L20.9913 20.3241C20.5025 19.8354 20.5025 19.0454 20.9913 18.5566Z",
    fill: "rgba(254, 119, 1, 1)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevert);
export default __webpack_public_path__ + "static/media/revert.eca30515d2b58ccda2354bb7faa93473.svg";
export { ForwardRef as ReactComponent };